import ModelState, {localised} from 'spa/state/_util/model';

const LOCALE_DEFAULT_CITY = {
  UK: 'UK-LONDON',
  FR: 'FR-PARIS',
};

@localised
class SpecialityByStubState extends ModelState {
  get method() { return 'GET'; }
  get url() { return '/speciality-by-stub'; }
  get singular() { return 'speciality'; }
  get plural() { return 'specialities'; }

  get defaultQuery() {
    if (this.ctx.i18n && this.ctx.i18n.umRegion) {
      return `city=${LOCALE_DEFAULT_CITY[this.ctx.i18n.umRegion]}`;
    }

    return null;
  }
}

export default SpecialityByStubState;



// WEBPACK FOOTER //
// ./spa/state/speciality-by-stub.jsx